import FeatureService from './FeatureService';
import Request from './request';
import FieldNames from "../defaults/FieldNames.json";
import ProjectService from './ProjectService';
import config from '../config.json';
import { mapGeomTypes } from '../utils/UploadHelper';

const defaults = {
  apiUrl: 'api',
  portalUrl: '',
  user: '',
  folder: '',
};

export default class Api {
  constructor(params) {
    this.props = Object.assign({}, defaults, params);
    this.basename = import.meta.env.BASE_URL;
    this.request = new Request();
  }

  getPortalUrl() {
    return this.props.portalUrl;
  }

  setPortalUrl(url) 
  {
    this.props.portalUrl = url;
  }

  getAppConfig() {
    return new Promise((resolve, reject) => {
        this.setPortalUrl(config.portalUrl);
        resolve(config);
        this.config = config;
    });
  }

  getUserGroups(userName, nifcToken) {
    return new Promise((resolve, reject) => {
      this.request.makeRequest({
        url: `${this.getPortalUrl()}/sharing/rest/community/users/${userName}`,
        method: 'post',
        data: { f: 'json', token: nifcToken }
      }).then(
        resp => resolve(resp),
        error => reject(error)
      )
    });
  }

  getActionByID(id){
    return this.getConcatenatedActionByObjectID(id);
  }

  getActionByObjectID(id, geometryType = "Polygon") {
    return FeatureService.getFeatureByObjectID(
      id,
      geometryType,
      true,
      "*"
    ).then((feature) => {
      if(feature?.attributes && !feature.attributes[FieldNames.featureFields.joinID])
      {
        feature.attributes[FieldNames.featureFields.joinID] = feature.attributes[FieldNames.featureFields.id];
        feature.attributes[FieldNames.featureFields.joinFeature] = geometryType;
      }
      return feature;
    }).catch(error => {
      return new Promise((resolve,reject) => {
        reject(error);
      });
    });
  }

  getProjectByNameIrwinIDFireCode(name, irwinID, fireCode){
    return ProjectService.getProjectByNameIrwinIDFireCode(name, irwinID, fireCode).then((projects) => {
      if(projects?.length){
        return projects;
      } else {
        return [];
      }
    }).catch(error => {
      return new Promise((resolve,reject) => {
        reject(error);
      });
    })
  }

  getProjectObjectIDByID(objectId){
    return ProjectService.getProjectObjectIDByID(objectId).then((project) => {
      return project;
    }).catch(error => {
      return new Promise((resolve,reject) => {
        reject(error);
      });
    })
  }

  getConcatenatedActionByObjectID(id) {
    return FeatureService.getConcatenatedFeatureViewByObjectID(
      id,
      false,
      "*"
    ).then((feature) => {
      if(feature?.attributes && !feature.attributes[FieldNames.featureFields.joinID])
      {
        feature.attributes[FieldNames.featureFields.joinID] = feature.attributes[FieldNames.featureFields.id];
      }
      return feature;
    }).catch(error => {
      return new Promise((resolve,reject) => {
        reject(error);
      });
    });
  }

  getActionByJoinValues(joinId, joinFeature) {
    return FeatureService.getViewFeatureByJoinValues(
      joinId,
      joinFeature,
      false
    ).then((feature) => {
      if(feature?.attributes && !feature.attributes[FieldNames.featureFields.joinID])
      {
        feature.attributes[FieldNames.featureFields.joinID] = joinId;
        feature.attributes[FieldNames.featureFields.joinFeature] = joinFeature;
      }
      return feature;
    }).catch(error => {
      return new Promise((resolve,reject) => {
        reject(error);
      });
    });
  }

  generateFeatureFromShapefile(params, file, config) {
    return new Promise((resolve, reject) => {
      //TODO: Fix URL
      this.request.upload(config.nifcUpload.url, file)
        .then(response => {
          if (response.featureCollection && response.featureCollection.layers.length > 0 && response.featureCollection.layers[0].featureSet.features.length > 0) 
          {
            const featureSet = response.featureCollection.layers[0].featureSet
            const geom = featureSet.features.find(feature => (feature.geometry !== null && feature.geometry !== undefined));
            const geomType = mapGeomTypes(featureSet.geometryType);
            if (geom )
            {
              // need to populate type on the geometry object using the FeatureSet geometryType
              geom.geometry.type = geomType;
              resolve(geom.geometry);
            }
            else 
            {
              reject();
            }
          }
          else {
            reject(response);
          }
        })
    });
  }
}
